import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, handleError, formatCNPJ } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import '../../../utils/Messages';
import * as defaultData from '../../../utils/DefaultData';

const masterProps = {
	title: 'Cadastro de Clientes',
	subtitle: 'Gerencie o cadastro de clientes',
};
const initialState = {
	customer: {
		id: null,
		name: '',
		corporateName: '',
		document: '',
		type: '',
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	},
	term: '',
};
export default class Customer extends Component {
	state = { ...initialState };
	customer = {
		id: null,
		name: '',
		corporateName: '',
		document: '',
		type: '',
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	};
	constructor(props) {
		super(props);
		this.loadListCustomers = this.loadListCustomers.bind(this);
		this.getCustomer = this.getCustomer.bind(this);
		this.deleteCustomer = this.deleteCustomer.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveCustomer = this.saveCustomer.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getCustomer(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('customers/' + key)
			.then(response => {
				this.customer = { ...response.data };
				this.setState({ ...this.state, customer: this.customer });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteCustomer(key) {
		API.delete('customers/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	saveCustomer() {
		this.crudForm.current.showLoadingPanel(true);
		let customer = { ...this.customer };
		if (customer.id === null) {
			API.post('customers/', customer)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					customer = response.data;
					this.customer = customer;
					this.setState({ customer: this.customer });
					// console.log(this.customer);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('customers/' + customer.id, customer)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.customer = customer;
					this.setState({ customer: this.customer });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListCustomers(page, pageSize) {
		let term = this.state.term;
		return API.get('/customers', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.customers,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteCustomer}
					fncGetData={this.getCustomer}
					fncListData={this.loadListCustomers}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{
							dataField: 'document',
							caption: 'CNPJ',
							width: '20%',
							datatType: 'text',
							calculateCellValue: function(data) {
								return formatCNPJ(data.document);
							},
						},
						{ dataField: 'name', caption: 'Razão Social' },
						{ dataField: 'corporateName', caption: 'Nome Fantasia' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						}
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.customer = { ...initialState.customer };
		this.setState({ ...this.state, customer: this.customer });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveCustomer();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};

	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<React.Fragment>
				<Form formData={this.customer} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
					<GroupItem colCount={5} caption={'Informações Básicas'}>
						<SimpleItem
							dataField={'id'}
							cssClass="uppercase"
							label={{ text: 'Código' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem
							dataField={'enabled'}
							editorType={'dxCheckBox'}
							label={{ text: 'Ativo' }}
							colSpan={4}
						/>
						<SimpleItem
							colSpan={4}
							dataField={'name'}
							cssClass="uppercase"
							label={{ text: 'Razão Social' }}
						/>
						<SimpleItem
							colSpan={1}
							dataField={'document'}
							editorOptions={{
								mask: '00.000.000/0000-00',
							}}
							cssClass="uppercase"
							label={{ text: 'CNPJ' }}
						/>
						<SimpleItem
							colSpan={4}
							dataField={'corporateName'}
							cssClass="uppercase"
							label={{ text: 'Nome Fantasia' }}
						/>

						<SimpleItem
							colSpan={1}
							dataField={'type'}
							editorType={'dxSelectBox'}
							cssClass="uppercase"
							editorOptions={{
								items: defaultData.typesCustomers,
								searchEnabled: true,
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							label={{ text: 'Categoria' }}
						/>
					</GroupItem>
					<GroupItem colCount={3} caption={'Informações de Contato'}>
						<SimpleItem
							colSpan={3}
							dataField={'contactInformation.name'}
							cssClass="uppercase"
							label={{ text: 'Nome de Contato', showColon: false }}
						/>
						<SimpleItem
							colSpan={3}
							dataField={'contactInformation.email'}
							label={{ text: 'E-mail', showColon: false }}
						/>
						<SimpleItem
							dataField={'contactInformation.phoneNumber'}
							editorOptions={{
								mask: '(00) 00000-0000',
							}}
							label={{ text: 'Celular', showColon: false }}
						/>
						<SimpleItem
							dataField={'contactInformation.homePhoneNumber'}
							editorOptions={{
								mask: '(00) 0000-0000',
							}}
							label={{ text: 'Telefone Residencial', showColon: false }}
						/>
						<SimpleItem
							dataField={'contactInformation.businessPhoneNumber'}
							editorOptions={{
								mask: '(00) 0000-0000',
							}}
							label={{ text: 'Telefone Comercial', showColon: false }}
						/>
					</GroupItem>
					<GroupItem>
						<div className="pull-right">
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button type="button" className="btn btn-success" onClick={this.onClickSave}>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</Form>
			</React.Fragment>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
